export const exercises = 'screens:exercise';
export const results = 'screens:results';
export const solutions = 'screens:solutions';
export const highscores = 'screens:highscores';
